import { useConnect } from '@lore/query-connect';

export default function useClaimsReal(state, network, schoolStart, schoolEnd, extra = {}, eager = {}) {
  return useConnect('claim.find', {
    where: {
      eager: {
        $where: {
          // ...offer_networkId(network),
          offer: {
            $where: {
              creator: {
                $where: {
                  state: {
                    $ilike: state
                  }
                }
              }
            }
          },
          createdAt: {
            $lte: schoolEnd,
            $gte: schoolStart
          },
          request: { $not: 'Outreach' },
          ...extra
        },
        $eager: eager
      }
    },
    pagination: {
      pageSize: 1000
    }
  });
}
